import * as React from "react";
const TestMini = (props) => (
  <svg
    width={14}
    height={13}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.22168 4.62793H10.3717"
      stroke="#4B5155"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.62793 4.62803L4.07793 5.07803L5.42793 3.72803"
      stroke="#4B5155"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.22168 8.82788H10.3717"
      stroke="#4B5155"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.62793 8.82798L4.07793 9.27798L5.42793 7.92798"
      stroke="#4B5155"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.2 12.5H8.8C11.8 12.5 13 11.3 13 8.3V4.7C13 1.7 11.8 0.5 8.8 0.5H5.2C2.2 0.5 1 1.7 1 4.7V8.3C1 11.3 2.2 12.5 5.2 12.5Z"
      stroke="#4B5155"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TestMini;
